<template>
  <div class="menuTemplate">
    <featuredParent 
      v-if="featuredScreen" 
      :featuredScreen="featuredScreen" 
      :playerInstance="playerInstance"
      @featuredContentLoaded="featuredContentLoaded">
    </featuredParent>
    
    <div class="home-slider-up-parent">
      <div :class="['home-slider-view', !featuredScreen ? 'home-slider-view-withoutFeature' : '']"
        v-if="categoryScreens.length > 0">
        
        <div v-for="(item, index) in categoryScreens" :key="item.id || item.sectionType + '-' + index">
          
          <continueSlider
            v-if="(item.sectionType === 'CONTINUEWATCH' || item.sectionType === 'CONTINUEWATCHING') && (item.status === 'ACTIVE' || item.isSectionEnabled) && subscriberid"
            :screen="item" 
            :playerInstance="playerInstance" 
            :screenId="screenId" 
            :counterTextV="index"
            :screenName="getIdValue(item.title.eng) + index" 
            :id="getIdValue(item.title.eng) + '-' + index">
          </continueSlider>
          
          <watchListSlider
            v-if="(item.sectionType === 'WATCHLIST') && (item.status === 'ACTIVE' || item.isSectionEnabled) && subscriberid"
            :screen="item" 
            :playerInstance="playerInstance" 
            :screenId="screenId" 
            :counterTextV="index"
            :screenName="getIdValue(item.title.eng) + index" 
            :id="getIdValue(item.title.eng) + '-' + index">
          </watchListSlider>
          
          <Slider v-if="
            item.sectionType !== 'CONTINUEWATCH' && item.sectionType !== 'CONTINUEWATCHING' && item.sectionType !== 'WATCHLIST' && item.sectionType !== 'USERRECOMMENDED' && item.sectionType !== 'TOPRECOMMENDED' &&
            (item.isSectionEnabled || item.status === 'ACTIVE') &&
            (!item.userTypes || item.userTypes.includes('ALL') || item.userTypes.includes(userType))
          " 
            :screen="item" 
            :id="getIdValue(item.title.eng) + '-' + index" 
            :playerInstance="playerInstance"
            :counterTextV="index" 
            :screenName="getIdValue(item.title.eng) + index" 
            :screenId="screenId">
          </Slider>
          
          <recommendationSlider v-if="
            (item.sectionType === 'USERRECOMMENDED' || item.sectionType === 'TOPRECOMMENDED') &&
            (item.isSectionEnabled || item.status === 'ACTIVE') &&
            (!item.userTypes || item.userTypes.includes('ALL') || item.userTypes.includes(userType))
          " 
            :screen="item" 
            :id="getIdValue(item.title.eng) + '-' + index" 
            :playerInstance="playerInstance"
            :counterTextV="index" 
            :screenName="getIdValue(item.title.eng) + index" 
            :screenId="screenId">
          </recommendationSlider>
          
        </div>
      </div>
    </div>
    
    <intersect v-if="categoryScreens.length < allCategoryScreens.length" :key="categoryScreens.length" @enter="inters" :root-margin="'0px 0px 400px 0px'" :threshold="[0.25]">
      <div style="width: 100%; height: 50px;"></div>
    </intersect>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import { mapGetters } from "vuex";
import Intersect from "vue-intersect";

export default {
  props: {
    screens: {
      type: Object,
      default: () => ({ sections: [] })
    },
    menu: {
      type: [Object, String],
      default: ""
    },
    playerInstance: {
      type: Object,
    },
    screenId: {
      type: String,
    }
  },
  data() {
    return {
      enableTemplate: false,
      templates: [],
      featuredScreen: null,
      allCategoryScreens: [], 
      categoryScreens: [],    
      pageSize: 3,            
      localDisplayLang: null,
      showHoveredColor: false,
      subscriptions: [],   
      startLoadSections: false
    };
  },
  computed: {
    ...mapGetters([
      "subscriberid",
      "getToken",
      "getRtl",
      "subscriptionList",
      "getFirebaseUserUID",
      "appConfig"
    ]),
    // FIX 4: Cached user type evaluation as a computed property to prevent executing a function multi-render loop inside v-for
    userType() {
      if (!this.subscriberid) {
        return "GUEST";
      } else if (this.subscriptions && this.subscriptions.length > 0) {
        return "SUBSCRIBED";
      } else {
        return "REGISTERED";
      }
    }
  },
  watch: {
    $route() {
      this.startLoadSections = false;
    },
    subscriberid(val) {
      if (val) {
        this.renderTemplate();
      }
    },
    subscriptionList: {
      handler(val) {
        if (val) {
          this.subscriptions = val;
        }
      },
      immediate: true
    },
  },
  created() {
    let lang = localStorage.getItem("setDisplayLanguageCode");
    this.localDisplayLang = lang === 'eng' ? 'en' : lang;

    eventBus.$on("check-local-storage", (data) => {
      this.localDisplayLang = data;
    });

    eventBus.$on("rerender-template", this.handleRerender);
  },
  mounted() {
    this.renderTemplate();
    this.renderMenuFilter();
  },
  methods: {    
    handleRerender() {
      this.renderTemplate();
      this.renderMenuFilter();
    },
    inters() {
      this.loadMoreCategories();
    },
    loadMoreCategories() {
      if (this.categoryScreens.length >= this.allCategoryScreens.length) return;
      
      const currentLength = this.categoryScreens.length;
      const nextBatch = this.allCategoryScreens.slice(currentLength, currentLength + this.pageSize);
      
      this.categoryScreens = [...this.categoryScreens, ...nextBatch];
    },
    getIdValue (str) {
      if (!str) return '_';
      return str.replace(/[^A-Z0-9]+/ig, "_");
    },
    renderTemplateUsingDecking() {
      const screensList = [];
      let currentProfileDetails = localStorage.getItem("subscriberProfileDetails");
      if (currentProfileDetails) {
        currentProfileDetails = JSON.parse(currentProfileDetails);
      }
      
      const kidsModeActive = this.subscriberid && currentProfileDetails?.kidsmode === "YES";
      let localFeatured = null;

      if (this.screens && Array.isArray(this.screens.sections)) {
        this.screens.sections.forEach((element) => {
          if (element.listType === "CAROUSEL") {
            if (kidsModeActive) {
              localFeatured = element;
            } else if (element.profileTypes?.some(p => ["ADULT", "MASTER", "ALL"].includes(p))) {
              localFeatured = element;
            }
          } else {
            if (kidsModeActive) {
              if (element.profileTypes?.includes("KIDS") || element.profileTypes?.includes("ALL")) {
                screensList.push(element);
              }
            } else if (element.profileTypes?.some(p => ["ADULT", "MASTER", "ALL"].includes(p))) {
              screensList.push(element);
            }
          }
        });
      }      

      // FIX 2: Bypassed heavy Vue 2 proxy setter traps by completely freezing large static asset items
      this.featuredScreen = localFeatured ? Object.freeze(localFeatured) : null;
      this.allCategoryScreens = Object.freeze(screensList);
      this.categoryScreens = this.allCategoryScreens.slice(0, this.pageSize);
    },
    renderTemplate() {
      if (this.appConfig?.featureEnabled?.isDeckingEnabled) {
          this.renderTemplateUsingDecking();
          return;
      }

      if (!this.screens || !Array.isArray(this.screens.sections)) return;

      const featured = this.screens.sections.find(element => element.sectionType === "FEATURED");
      const categories = this.screens.sections.filter(element => element.sectionType !== "FEATURED");
      
      // FIX 2: Freezing elements in the fallback configuration path as well
      this.featuredScreen = featured ? Object.freeze(featured) : null;
      this.allCategoryScreens = Object.freeze(categories);
      this.categoryScreens = this.allCategoryScreens.slice(0, this.pageSize);
    },
    renderMenuFilter() {
      const payload = {
        state: !!(this.menu && this.menu.hasOwnProperty("hasFilter") && this.menu.hasFilter),
        menu: this.menu || null
      };
      eventBus.$emit("toggleMenuFilter", payload);
      window.scrollTo(0, 0);
    },
    featuredContentLoaded() {
      this.startLoadSections = true;
    }
  },
  beforeDestroy() {
    this.startLoadSections = false;
    eventBus.$off("rerender-template", this.handleRerender);
    eventBus.$off("check-local-storage");
  },
  components: {
    featuredParent: () => import("@/components/Carousels/featuredParent.vue"),
    Slider: () => import('@/components/categorySlider/slider.vue'),
    recommendationSlider: () => import('@/components/categorySlider/recommendationSlider.vue'),
    continueSlider: () => import("@/components/categorySlider/continueSlider.vue"),
    watchListSlider: () => import("@/components/categorySlider/watchListSlider.vue"),
    Intersect
  }
};
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "./menuTemplate.scss";
</style>